import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: 16,
          lineHeight: 1.5,
        },
      },
    },
  },
});

export default theme.components;
